import { Alert, Button, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import packageJson from '../../package.json';

const CHECK_EVERY_MS = 5 * 60 * 1000;

// Fleet devices keep the app open for days or weeks, so stale tabs keep
// running (and reporting errors from) long-replaced builds. Poll the
// version.json emitted by each build and prompt for a reload when the
// deployed version no longer matches the one baked into this bundle.
export default function NewVersionPrompt() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);

  useEffect(() => {
    if (!import.meta.env.PROD) {
      return undefined;
    }

    let cancelled = false;

    const check = async () => {
      try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        if (!response.ok) {
          return;
        }
        const { version } = await response.json();
        if (!cancelled && version && version !== packageJson.version) {
          setNewVersionAvailable(true);
        }
      } catch (ignored) {
        // offline or mid-deploy - retry on the next tick
      }
    };

    const interval = setInterval(check, CHECK_EVERY_MS);
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        check();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return (
    <Snackbar open={newVersionAvailable} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert
        severity="info"
        action={
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            Reload
          </Button>
        }
      >
        A new version of the app is available.
      </Alert>
    </Snackbar>
  );
}
